var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((_vm.options),function(option){return _c('i',{key:option.value,staticClass:"mr-1 cursor-pointer ds-text-2xl last:mr-0",class:{
            [option.icon]: true,
            'text-gray-700': option.value === _vm.value,
            'text-gray-500': option.value !== _vm.value,
        },on:{"click":function($event){return _vm.$emit('input', option.value)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }